<template>
  <no-ssr>
    <el-container>
      <el-header
        v-show="!['/tpl/personSet', '/tpl/general', '/tpl/accountInfo', '/tpl/costStatistics', '/tpl/signers', '/tpl/corpSet', '/tpl/Preferences', '/tpl/myAuth'].includes($route.path)"
        :class="{
          'my-el-header': true,
          homePage: isInDingTalk
            ? false
            : isHomePage && isScrollChange && useThisHeader,
        }"
      >
        <div class="header">
          <el-row type="flex">
            <el-col :span="3" class="jzq-logo">
              <a
                :href="
                  isInDingTalk
                    ? '/viewIndex'
                    : globalConfig.domain.junziqanIndex
                "
              >
                <!-- <img src="/images/ptlogo.png"/> -->
                <img src="/images/logo/jzq-logo.png" alt />
              </a>
            </el-col>
            <!--导航菜单-->
            <el-col
              :span="15"
              :style="{
                display:
                  isInDingTalk && $route.path === '/auth/authGuide'
                    ? 'none'
                    : 'block',
              }"
            >
              <nav v-show="showMenu">
                <!--普通账户（超级管理员）-->
                <ul
                  v-if="
                    currentAuthUser.userType == 0 ||
                    currentAuthUser.userType == 1
                  "
                >
                  <li
                    :class="
                      $route.path.indexOf('viewIndex') !== -1 ? 'active' : ''
                    "
                  >
                    <router-link class="item" to="/viewIndex">首页</router-link>
                  </li>
                  <li
                    :class="
                      ($route.path.indexOf('signInfo') !== -1 && !['/signInfo/entAccess', '/signInfo/viewDealTypeList'].includes($route.path)) ? 'active' : ''
                    "
                  >
                    <span
                      class="item"
                      @click="
                        turnFilePage({
                          path: '/signInfo/signList',
                          query: { signStatus: 2 },
                        })
                      "
                    >文件管理</span>
                  </li>
                  <li
                    style="cursor: pointer"
                    @click="pageChangeFn"
                    :class="
                      $route.path.indexOf('judicialService') !== -1
                        ? 'active'
                        : ''
                    "
                  >
                    <div class="item">司法服务</div>
                  </li>
                  <!-- API对接菜单入口常驻显示 -->
                  <!-- v-if="$store.getters.currentAuthUser.merchantFlag === 1" -->
                  <li
                    v-if="$store.getters.currentAuthUser.userType === 1"
                    style="cursor: pointer"
                    @click="APIabutment"
                    :class="
                      ['/signInfo/viewDealTypeList', '/signInfo/entAccess'].includes($route.path)? 'active'
                        : ''
                    "
                  >
                    <div class="item">API对接</div>
                  </li>
                  <!--                  业务定制系统菜单在  headandfullpage 页面也要同样的菜单,（因为layout不同）-->
                  <li :class="isSmart ? 'active' : ''" v-if="!isInDingTalk && (accountInfoVO.userType === 1 || bindCorpUsersList.length === 1)">
                    <!-- <router-link class="item" to="/smartDoc/docDraft/draftList"
                      >合同机器人
                    </router-link>-->
                    <span class="item" @click="ywtIntroductionFn">业务定制系统</span>
                  </li>
                  <li :class="isSmart ? 'active' : ''" v-else-if="!isInDingTalk && bindCorpUsersList.length > 1">
                    <el-dropdown  @command="handleCommandFn">
                      <span class="el-dropdown-link item">业务定制系统</span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                          v-for="(item, index) in bindCorpUsersList"
                          :key="index"
                          v-show="item.userStemFrom !== -16"
                          :command="item">{{item.corpName}}</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </li>
                </ul>

                <!--集团账户-->
                <ul
                  v-else-if="
                    currentAuthUser.superFlag == 0 ||
                    currentAuthUser.superFlag == 1
                  "
                >
                  <li
                    :class="
                      $route.path.indexOf('viewIndex') !== -1 ? 'active' : ''
                    "
                  >
                    <!-- <router-link class="item" to="/corp/viewIndex" -->
                    <router-link class="item" to="/viewIndex">首页</router-link>
                  </li>
                  <li
                    :class="
                      $route.path.indexOf('signInfo') !== -1 ? 'active' : ''
                    "
                  >
                    <span
                      class="item"
                      @click="
                        turnFilePage({
                          path: '/corp/signInfo/signList',
                          query: { signStatus: 4 },
                        })
                      "
                    >文件管理</span>
                  </li>
                  <li
                    style="cursor: pointer"
                    @click="pageChangeFn"
                    :class="
                      $route.path.indexOf('judicialService') !== -1
                        ? 'active'
                        : ''
                    "
                  >
                    <div class="item">司法服务</div>
                  </li>
                  <li :class="isSmart ? 'active' : ''" v-if="!isInDingTalk && (accountInfoVO.userType === 1 || bindCorpUsersList.length === 1)">
                    <span class="item" @click="ywtIntroductionFn">业务定制系统</span>
                  </li>
<!--                  业务定制系统菜单在  headandfullpage 页面也要同样的菜单,（因为layout不同）-->
                  <li :class="isSmart ? 'active' : ''" v-else-if="!isInDingTalk && bindCorpUsersList.length > 1">
                    <el-dropdown  @command="handleCommandFn">
                      <span class="el-dropdown-link item">业务定制系统</span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                          v-for="(item, index) in bindCorpUsersList"
                          :key="index"
                          v-show="item.userStemFrom !== -16"
                          :command="item">{{item.corpName}}</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </li>
                </ul>
              </nav>
            </el-col>

            <!--右侧用户弹出窗-->
            <el-col :span="6" style="padding-left: 20px; box-sizing: border-box">
              <el-row v-if="!isInDingTalk">
                <!-- :style="{
                  display:
                    isInDingTalk && $route.path === '/auth/authGuide' || isInDingTalk && $route.path === '/dingtalkUse/personAuth' || isInDingTalk && $route.path === '/dingtalkUse/authentication'
                      ? 'none'
                      : 'block',
                }"-->
                <user-header style="float: right" />
              </el-row>
            </el-col>
          </el-row>
        </div>
      </el-header>
      <!--      个人控制台-->
      <userConsoleHeader />
      <!--      |||||-->
      <div class="y-header" style="height: 60px"></div>
      <!--    区块链查询 end-->
      <el-dialog
        title="添加集团账户电子签署系统"
        :visible.sync="createCorpShow"
        :close-on-click-modal="false"
        width="30%"
        class="dialog"
      >
        <el-form :model="createCorpInfo" ref="createCorpForm">
          <el-form-item label="集团名称">
            <el-input
              v-model="createCorpInfo.name"
              autocomplete="off"
              placeholder="50字以内，可不填"
              maxlength="50"
              :clearable="true"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="createCorpShow = false">取 消</el-button>
          <el-button type="primary" @click="handleCreateCorp">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 未开通API服务提示弹窗 -->
      <el-dialog
        title="提示"
        :visible.sync="apiOpenShow"
        :close-on-click-modal="false"
        width="30%"
        class="dialog"
      >
        <p>未开通君子签API服务，是否开通？</p>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="apiOpenShow = false">暂不开通</el-button>
          <el-button type="primary" size="mini" :loading="apiOpening" @click="handleOpenMerchant">立即开通</el-button>
        </div>
      </el-dialog>
      <el-main v-if="isRouterAlive">
        <nuxt />
      </el-main>
      <suspend v-show="showMenu"></suspend>
      <!--    <security-chain v-if="$route.path === '/blockChain'"></security-chain>-->
      <contacts
        v-if="$route.path === '/viewIndex' && !isInDingTalk"
        @showCorpAds="gotoEnd"
        ref="contact"
      />
      <my-footer v-show="showMenu" />
      <!-- 
        禅道bug编号【11171】隐藏该项
        <authentication-tips :local="isEnd" /> 
      -->
    </el-container>
  </no-ssr>
</template>

<script>
import { ding_erformance } from "./js/entConsoleDate.js"
import Cell from "@/components/cell/index";
import {
  logout,
  ApiMethods,
  fileOperShow,
} from "../assets/js/http-serve/http-methods";
import { ApiCorpMethods, addMerchant } from "../assets/js/http-serve/corp/http-methods";
import {
  getCorpToken,
  loginOrRefresh,
  setCurrentUser,
} from "../assets/js/http-serve/corp/common";
import { corpToNormal, normalToCorp } from "@/assets/js/lib/common";
import Contacts from "@/components/contacts/index";
import ChangeAccount from "@/components/change-account";
import BlockBanner from "@/components/blockChain/banner";
import JudicialServiceBanner from "@/components/judicialService/banner";
import SecurityChain from "@/components/blockChain/securityChain";
import UserHeader from "@/components/header/userHeader.vue";
import MyFooter from "@/components/myfooter/index.vue";
import AuthenticationTips from "../components/authentication-tips/index";
import { gantConf } from "../assets/js/utils/jurisdiction";
import { NotRequiredList } from "../assets/js/utils/dingRouters";
import { isInDingTalk } from "../assets/js/utils/ding-env";
import userConsoleHeader from "../components/header/userConsoleHeader"
import { mapGetters } from "vuex";

export default {
  data () {
    return {
      isInDingTalk,
      logout: logout,
      setCurrentUser: setCurrentUser,
      fileOperShow: fileOperShow,
      noSign: false,
      height: 700,
      userPointCnt: 0,
      userType: this.$store.getters.userType,
      allUser: this.$store.getters.allAuthUser,
      createCorpShow: false, //是否显示创建集团系统
      createCorpInfo: {},
      apiOpenShow: false, //是否显示API服务开通提示弹窗
      apiOpening: false, //是否正在开通API服务
      accountList: [], //账户数组
      totalAccountList: [],
      searchText: "", //搜索账户 内容，用于清空
      isRouterAlive: true,
      showExpand: false,
      useThisHeader: true, // heder是否使用当前class
      judicialServicePathArr: [
        "/judicialService/introduce", //介绍
        "/judicialService/arbitration", //广仲案件
        "/judicialService/taiarbitration", //台州仲案件
        "/judicialService/ganarbitration", //赣国仲案件
        "/judicialService/zharbitration", //珠仲案件
        "/judicialService/safeguard", //在线公证
        "/judicialService/baoguanhan", //公证保管函
      ],
      dingPathList: NotRequiredList,
      isEnd: false,
    //  ywt相关
      whetherActivateYwt: false,
    };
  },
  provide () {
    return {
      reload: this.reload,
    };
  },
  filters: {
    lth7 (val) {
      if (val && val.length > 7) {
        return val.slice(0, 7) + "...";
      }
      return val;
    },
  },
  async beforeMount () {
    // 没有用户数据时，刷新页面，重新获取
    if (
      !(
        this.$store.getters.currentAuthUser.userName ||
        this.$store.getters.currentAuthUser.name
      )
    ) {
      let refreshRes = await loginOrRefresh();
      console.log("refreshRes", refreshRes);
      if (!refreshRes.success) {
        this.reload();
      }
    }
    // 超级管理员，不应该进入SAAS（切换到普通账户）
    if (this.$store.getters.currentAuthUser.superFlag === 1) {
      await setCurrentUser(this.$store.getters.allAuthUser.accountInfoVO);
    }
  },
  mounted () {
    this.height = document.body.clientHeight - 110;
    this.initAccountList();
    ding_erformance()
  },
  async created () {
    await this.isSign();
    const isDing = this.dingPathList.includes(window.location.pathname);
    if (!isDing) await this.getUserPointCnt();
    document.addEventListener(
      "scroll",
      this.debounce(this.scrollChangeHeader, 200),
      false
    );
    document.addEventListener(
      "scroll",
      this.debounce(this.scrollBottom, 200),
      false
    );

    this.$reCharts.windowResizeECharts();
  },
  beforeDestroy () {
    document.removeEventListener("scroll", this.scrollChangeHeader, false);
    document.removeEventListener("scroll", this.scrollBottom, false);
    this.$reCharts.clearWindowResizeEChartsFn();
  },
  computed: {
    ...mapGetters(["allAuthUser"]),
    bindCorpUsersList () {
      return this.$store.getters.allAuthUser.bindCorpUsers;
    },
    accountInfoVO () {
      if (this.allAuthUser && this.allAuthUser.accountInfoVO) {
        return this.allAuthUser.accountInfoVO;
      }
      return {};
    },
    showMenu () {
      // 实名认证页面 如果是saas api发起只保留logo
      const { path } = this.$route;
      const { multiSignatoryKey } = this.$route.query;
      const namePath =
        path === "/auth/authGuide" || path === "/auth/personalIdentityAuth";
      return namePath && multiSignatoryKey ? false : true;
    },
    // 是否在智能工具页面
    isSmart () {
      let pathC = this.$route.path;
      let active =
        pathC.indexOf("smartContract") > -1 ||
        pathC.indexOf("blockChain") > -1 ||
        pathC.indexOf("smartDoc") > -1;
      return active;
    },
    /**
     * 集团用户判断是否显示企业控制台按钮
     * @returns {boolean}
     */
    isShowConsoleEntry () {
      try {
        //管理员，显示控制台按钮
        if (this.$store.getters.currentAuthUser.superFlag == 1) {
          return true;
        }
        //无法获取当前用户，不显示控制台按钮
        if (!this.$store.getters.currentAuthUser) {
          return false;
        }
        //当前用户的consoleToken中，perms有值，则显示控制台按钮
        if (
          this.$store.getters.consoleToken &&
          this.$store.getters.consoleToken.perms &&
          this.$store.getters.consoleToken.perms.length > 0
        ) {
          // 判断是否有权限
          if (this.$store.getters.consoleToken.perms[0]) {
            return true;
          } else {
            return false;
          }
        }
        return false;
      } catch (e) {
        console.log(e);
      }
    },
    /**
     * 普通用户判断是否显示企业控制台按钮
     * @returns {boolean}
     */
    isShowNormalConsoleEntry () {
      try {
        //超级管理员
        if (this.$store.getters.allAuthUser.corpCreateFlag == 1) {
          return true;
        }
        // 企业用户，统统显示
        if (this.$store.getters.currentAuthUser.userType === 1) {
          return true;
        }
        return false;
      } catch (e) {
        console.log(e);
      }
    },
    currentAuthUser () {
      return this.$store.getters.currentAuthUser || {};
    },
    showSearch () {
      return (
        this.totalAccountList.length > 5 ||
        this.totalAccountList.length > this.height / 70
      );
    },
    isCorpUser () {
      try {
        return this.currentAuthUser.superFlag !== undefined;
      } catch (e) {
        return false;
      }
    },
    /**
     *  是否首页-首页需要显示顶部banner
     * */
    isHomePage () {
      let path = this.$route.path;
      if (path.indexOf("viewIndex") > -1) {
        return true;
      }
      return false;
    },
    /**
     *  是否在页面上下滚动时改变header颜色
     * */
    isScrollChange () {
      let path = this.$route.path;
      if (
        path.indexOf("viewIndex") > -1 ||
        path === "/blockChain" ||
        this.judicialServicePathArr.indexOf(path) !== -1
      ) {
        return true;
      }
      return false;
    },
    getTitle () {
      let name = this.currentAuthUser.name || this.currentAuthUser.corpName;
      let accountName = this.$store.getters.allAuthUser
        ? this.$store.getters.allAuthUser.accountInfoVO.name
        : "";
      return name !== accountName ? name + "-" + accountName : name;
    },
  },
  watch: {
    "$store.getters.currentAuthUser": {
      handler (newVal, oldVal) {
        if (!this.$store.state.ignoreChangePage) {
          // 需要重定向
          this.changePageByCurrentUser({
            oldUserInfo: oldVal,
            newUserInfo: newVal,
          });
        }
      },
      deep: true,
    },
    // 检测全部用户是否更新，调用initAccountList函数初始化用户列表
    "$store.getters.allAuthUser": {
      handler (val) {
        this.initAccountList();
      },
      deep: true,
    },
    searchText: {
      handler (val) {
        this.doFilter(val);
      },
    },
  },
  methods: {
    //成员跳转ywt系统
    handleCommandFn(item) {
      //先获取成员账号的临时token，_ctToken参数可以临时设置请求token，ut还是ct来着现成有的，(在首页就要查询成员的ywt状态，又不能切换当前currentuser)
      getCorpToken(item.corpUserId).then(result => {
        // 请求的时候带上临时token
        ApiMethods.ProfileController.ywtUserActivateStatus({_ctToken: result.data}).then(res => {
          //1: 主账号子账号都开通了。4： 主账号开通，子账号未开通
          this.$router.push({
            path: [1, 4].includes(res.data) ? '/ywtRelated/guidancePage' :'/ywtRelated/introductionPage',
            query: {
              status: res.data,
              corpUserId: item.corpUserId || '',
          }
          })
        })
      })
    },
    //主账号跳转ywt系统
    ywtIntroductionFn () {
      //成员账号，但只加入了一个企业不用选择下拉框，默认选择第一项
      if (this.bindCorpUsersList.length === 1) {
        this.handleCommandFn(this.bindCorpUsersList[0])
      } else { //企业主账号跳转
        ApiMethods.ProfileController.ywtActivateStatus().then(res => {
          this.$router.push({
            path: res.data === 1 ? '/ywtRelated/guidancePage' :'/ywtRelated/introductionPage',
            query: {
              status: res.data,
          }
        })
        })
      }
    },
    //API对接
    APIabutment () {
      // 未实名认证，弹实名认证提示
      if (this.$store.getters.authUser.identityAuth === -1) {
        return this.realName();
      }
      // 当前用户为商户，直接进入API对接页面；否则弹窗提示开通
      if (this.$store.getters.currentAuthUser.merchantFlag === 1) {
        this.$router.push({
          path: "/signInfo/entAccess", query: {
            typeStatus: 'apiSet'
          }
        });
      } else {
        this.apiOpenShow = true;
      }
    },
    //立即开通君子签API服务（自动开通商户并生成appkey）
    handleOpenMerchant () {
      this.apiOpening = true;
      addMerchant({})
        .then(res => {
          if (res.success) {
            this.apiOpenShow = false;
            this.$message.success("开通成功");
            // 同步更新store中的商户标识，避免再次点击API对接时重复弹出开通弹窗
            this.$store.commit("SET_IGNORECHANGEPAGE", true);
            this.$store.dispatch("setCurrentAuthUser", {
              ...this.$store.getters.currentAuthUser,
              merchantFlag: 1
            }).then(() => {
              this.$store.commit("SET_IGNORECHANGEPAGE", false);
            });
            this.$router.push({
              path: "/signInfo/entAccess", query: {
                typeStatus: 'apiSet'
              }
            });
          } else {
            this.$message.error(res.description || "开通失败，请稍后重试");
          }
        })
        .catch(() => {
          this.$message.error("开通失败，请稍后重试");
        })
        .finally(() => {
          this.apiOpening = false;
        });
    },
    roleChange (user) {
      setCurrentUser(user).finally(() => {
        if (
          this.$store.getters.currentAuthUser &&
          this.$store.getters.currentAuthUser.corpUserId
        ) {
          this.$router.push({
            path: "/corp/signInfo/signList",
            query: { signStatus: 4 }
          }, () => { }, () => { });
        }
      });
    },
    turnFilePage (routePath) {
      if (isInDingTalk) {
        let bindCorpUsers = this.$store.getters.allAuthUser.bindCorpUsers;
        // 钉钉环境
        const info = JSON.parse(sessionStorage.getItem("dingloginInfo"));
        let user = bindCorpUsers.filter(user => info.jzqCorpId === user.corpId);
        this.roleChange(user[0])
      } else {
        if (this.$store.getters.allAuthUser.bindCorpUsers[0] && this.$store.getters.allAuthUser.accountInfoVO.identityAuth === 1) {
          this.roleChange(this.$store.getters.allAuthUser.bindCorpUsers[0]);
        } else {
          this.$router.push(routePath, () => { }, () => { })
        }
      }
    },
    pageChangeFn () {
      let user = [this.$store.getters.allAuthUser.accountInfoVO];
      const RealNameStatus = this.$store.getters.authUser.identityAuth === -1
      // if (!(user && user.identityAuth === 1)) {
      //   return this.$router.push("/judicialService/safeguard", () => { }, () => { });
      // }
      if (RealNameStatus) return this.realName()
      let { memberCert, arbitrate } = gantConf, userArr = [], havePerm = null;
      this.$store.getters.allAuthUser.bindCorpUsers.forEach(userItem => {
        if (userItem.perms.includes(memberCert) || userItem.perms.includes(arbitrate)) {
          userArr.push(userItem);
        }
      });
      if (isInDingTalk) {
        const info = JSON.parse(sessionStorage.getItem("dingloginInfo"));
        userArr = this.$store.getters.allAuthUser.bindCorpUsers.filter(user => {
          return info.jzqCorpId === user.corpId && (user.perms.includes(memberCert) || user.perms.includes(arbitrate));
        });
        // havePerm= userArr.length > 0 && (userArr[0].perms.includes(memberCert) || userArr[0].perms.includes(arbitrate))
      }
      const param = userArr.length ? userArr[0] : user[0]
      console.log('param', param);
      setCurrentUser(param).then(
        res => {
          this.$router.push("/judicialService/safeguard", () => { }, () => { });
        }
      );
    },
    realName () {
      this.$confirm(
        "您的账号还未完成实名认证，无法使用完整功能！",
        "提示",
        {
          confirmButtonText: "去认证",
          cancelButtonText: "以后再说",
          type: "warning"
        }
      )
        .then(() => {
          this.gotoAuth();
        })
        .catch(() => { });
    },
    gotoAuth () {
      if (this.$store.getters.authUser.userType === 0) {
        this.$router.push("/auth/personalIdentityAuth");
      } else {
        this.$router.push("/auth/authGuide");
      }
    },
    //banner跳转
    bannerJump (url) {
      if (url) {
        window.open(url);
      }
    },
    // 防抖函数
    debounce (fn, delay) {
      let timer = null; //借助闭包
      return function () {
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(fn, delay); // 简化写法
      };
    },
    scrollBottom () {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      let clientHeight = document.documentElement.clientHeight;
      let scrollHeight = document.documentElement.scrollHeight;
      if (scrollTop + clientHeight >= scrollHeight) {
        this.isEnd = true;
      } else {
        this.isEnd = false;
      }
    },
    reload () {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    getUserPointCnt: function () {
      var _this = this;
      ApiMethods.ProfileController.userPoint({}).then((result) => {
        if (result.success) {
          _this.userPointCnt = result.data;
        } else {
          _this.$message.error(result.description || this.$tip);
        }
      });
    },
    signIn: function () {
      var _this = this;
      ApiMethods.ProfileController.todaySigneIn({}).then((result) => {
        if (result.success) {
          _this.noSign = false;
          _this.$message.success("签到成功");
        } else {
          return _this.$message.error("签到失败:" + result.description);
        }
      });
    },
    isSign: function () {
      var _this = this;
      ApiMethods.ProfileController.todayNoSigned({}).then((result) => {
        if (result.success) {
          _this.noSign = result.data;
        }
      });
    },
    async handleConsoleClick () {
      let currentUser = this.$store.getters.currentAuthUser;
      let allUser = this.$store.getters.allAuthUser;
      //判断是不是普通账号（超级管理员绑定在普通账号）
      if (
        (currentUser && currentUser.userType == 0) ||
        currentUser.userType == 1
      ) {
        if (allUser) {
          // 可创建
          if (allUser.corpCreateFlag == 1) {
            // 未创建
            if (!(allUser.manCorpUser && allUser.manCorpUser.corpUserId)) {
              // 显示创建
              this.createCorpShow = true;
            }
            // 已创建
            else {
              // 直接进入集团控制台
              this.$router.push("/console");
            }
          }
          // 其他情况，显示集团控制台开通方式
          else {
            this.gotoEnd();
          }
        } else {
          this.$message.error("进入集团账户失败，请刷新重试");
        }
      }
      // 集团账户
      else {
        if (
          this.$store.getters.consoleToken &&
          this.$store.getters.consoleToken.perms &&
          this.$store.getters.consoleToken.perms.length > 0
        ) {
          // 有权限，直接进入
          this.$router.push("/console");
        } else {
          this.$message.info("您暂无控制台权限，请联系集团管理员");
        }
      }
    },
    handleCreateCorp () {
      //创建组织
      let corpName = this.createCorpInfo.name;
      ApiCorpMethods.CorpController.createCorp(corpName)
        .then((res) => {
          if (res.success) {
            loginOrRefresh()
              .then((refreshRes) => {
                if (!refreshRes.success) {
                  window.location.reload();
                }
              })
              .catch(() => { });
            this.$confirm(
              `${res.description || "创建集团系统成功"}，立即进入控制台？`,
              "系统提示",
              {
                showConfirmButton: true,
                showCancelButton: true,
                type: "info",
              }
            )
              .then(() => {
                this.$router.push("/console");
              })
              .catch(async () => {
                this.$message({
                  message: res.description || "创建集团系统成功",
                });
                let refreshRes = await loginOrRefresh();
                if (!refreshRes.success) {
                  window.location.reload();
                }
                this.createCorpShow = false;
                this.createCorpInfo.name = "";
              });
          } else {
            this.$message.error(res.description || "创建集团系统失败");
          }
          this.createCorpShow = false;
          this.createCorpInfo.name = "";
        })
        .catch((err) => {
          this.createCorpShow = false;
          this.createCorpInfo.name = "";
          console.log(err);
        });
    },
    changePageByCurrentUser ({ oldUserInfo, newUserInfo }) {
      try {
        if (oldUserInfo.superFlag !== undefined) {
          // 从集团账户来
          if (newUserInfo.superFlag !== undefined) {
            // 到集团账户去
            // 归档文件夹路径
            if (this.$route.fullPath.indexOf("directoryId") !== -1) {
              // 跳转到外层（发件箱或收件箱）
              this.$router.push({
                path: this.$route.path,
                query: {
                  match: -1,
                },
              });
              // 需要刷新一下
              this.$nextTick(() => {
                this.reload();
              });
            }
            // 普通路径，刷新
            else {
              this.reload();
            }
          }
          // 到普通账户去
          else {
            // 归档文件夹路径
            if (this.$route.fullPath.indexOf("directoryId") !== -1) {
              // 跳转到外层（发件箱或收件箱）
              this.$router.push({
                path: this.$route.path.replace("/corp", ""),
                query: {
                  match: -1,
                },
              });
            }
            // 普通路径 跳转
            else {
              corpToNormal({ route: this.$route, router: this.$router });
            }
          }
        } else if (oldUserInfo.userType !== undefined) {
          //从普通账户来
          if (newUserInfo.superFlag !== undefined) {
            // 归档文件夹路径
            if (this.$route.fullPath.indexOf("directoryId") !== -1) {
              // 跳转到外层（发件箱或收件箱）
              this.$router.push({
                path: "/corp" + this.$route.path,
                query: {
                  match: -1,
                },
              });
            }
            // 普通路径 跳转
            else {
              normalToCorp({ route: this.$route, router: this.$router });
            }
          } else {
            // 到普通账户去（此种情况暂不存在）
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
    // 初始化账户列表
    initAccountList () {
      this.accountList = [];
      if (
        this.$store.getters.allAuthUser &&
        this.$store.getters.allAuthUser.bindCorpUsers
      ) {
        this.$store.getters.allAuthUser.bindCorpUsers.forEach((user) => {
          this.accountList.push(user);
          this.totalAccountList.push(user);
        });
      }
      this.accountList.push(this.$store.getters.allAuthUser.accountInfoVO);
      this.totalAccountList.push(this.$store.getters.allAuthUser.accountInfoVO);
    },
    // 搜索账户列表
    doFilter (val) {
      try {
        if (val) {
          this.accountList = [];
          // 循环搜索加入企业的账户
          this.$store.getters.allAuthUser.bindCorpUsers.forEach((user) => {
            if (user.corpName.indexOf(val) != -1) {
              this.accountList.push(user);
            }
          });
          // 搜索原账户
          if (
            this.$store.getters.allAuthUser.accountInfoVO.name.indexOf(val) !=
            -1
          ) {
            this.accountList.push(
              this.$store.getters.allAuthUser.accountInfoVO
            );
          }
        } else {
          // 初始化账户列表
          this.initAccountList();
        }
      } catch (e) {
        console.log(e);
      }
    },
    // 切换用户时，也要清空搜索文字
    changeAccount (user) {
      this.searchText = "";
      this.setCurrentUser(user);
    },
    gotoEnd () {
      const url =
        this.globalConfig.domain.junziqianMain + "/groupAccounts.html";
      window.open(url);
    },
    showExpandIcon () {
      this.showExpand = true;
    },
    toProfile () {
      if (this.isCorpUser) {
        // this.$router.push({path:'/signSettings/signers'})
      } else {
        this.$router.push({ path: "/signSettings/accountInfo" });
      }
    },
    /**
     *  页面滚动时改变header颜色
     * */
    scrollChangeHeader () {
      if (!this.isScrollChange) return false;
      if (window.pageYOffset > 90) {
        this.useThisHeader = false;
      } else {
        this.useThisHeader = true;
      }
    },
  },
  components: {
    Cell,
    Contacts,
    ChangeAccount,
    BlockBanner,
    SecurityChain,
    JudicialServiceBanner,
    UserHeader,
    userConsoleHeader,
    MyFooter,
    AuthenticationTips,
  },
};
</script>

<style lang="less" scoped>
.el-main {
  /*max-width: 1200px;*/
  max-width: 1366px;
  margin: 0 auto;
  width: 100%;
}

.header {
  /*max-width: 1366px;*/
  max-width: 1326px;
  margin: 0 auto;

  .jzq-logo {
    height: 60px;
    line-height: 60px;
  }

  .profile-mini {
    position: relative;
    z-index: 10;
    line-height: 60px;
    height: 60px;
    margin-left: 26px;
    max-width: 200px;
    text-align: right;

    .top-profile {
      display: inline-block;
      position: relative;
      width: 100%;
      margin-left: -22px;
      line-height: 60px;
      height: 60px;
      white-space: nowrap;
      cursor: pointer;
    }

    a {
      position: relative;
      max-width: 100%;
      padding: 0 0 0 22px;
      margin-left: -22px;
      z-index: 1;
      display: inline-block;
      color: #cccccc;

      .name {
        display: inline-block;
        vertical-align: middle;
        max-width: 140px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      .profile-down {
        margin-top: -3px;
        font-size: 20px;
        color: #cccccc;
        transition: all 0.3s;
        vertical-align: middle;
      }
    }

    .el-icon-arrow-right {
      font-size: 16px;
      transition: all 0.2s linear;
      vertical-align: middle;
      margin-bottom: 2px;
      margin-left: 15px;
    }

    img {
      margin-right: 10px;
    }

    &:hover {
      .profile-down {
        transform: rotate(-90deg);
      }

      .profile-expand {
        width: 130%;
        /*z-index: 2;*/
        transform: translateY(0);
        opacity: 1;
      }

      .el-icon-arrow-right {
        transform: rotate(90deg);
      }
    }

    /deep/ .change-account .d-box {
      max-width: 160px;
    }

    /deep/ .profile-expand {
      transition: all 0.3s;
      margin-left: -20px;
      position: absolute;
      opacity: 0;
      top: 60px;
      z-index: -1;
      border-radius: 5px;
      overflow: hidden;
      box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.16);
      left: 2px;
      background-color: #ffffff;
      transform: translateY(-100%);
      color: #000000;
      width: 130%;

      .search-profile {
        position: absolute;
        background-color: #ffffff;
        padding: 0 20px;
        border-bottom: solid 1px #ddd;
      }

      .wrap {
        overflow-y: auto;
        max-height: 420px;
      }

      li {
        border-bottom: solid 1px #ddd;
        padding: 10px 80px 10px 10px;
        transition: all 0.5s;

        .current-user {
          right: 15px;
        }
      }
    }

    .photo {
      max-width: 30px;
      max-height: 30px;
      border-radius: 50%;
      /*border: solid 1px #696969;*/
    }
  }

  .user-sider {
    .header-usr {
      position: relative;
      width: 100%;
      padding-right: 16px;
      display: inline-block;
      height: 66px;
      line-height: 66px;
      font-size: 15px;
      color: #cccccc;
      white-space: nowrap;
      overflow-x: hidden;
      text-overflow: ellipsis;

      img {
        width: 36px;
        height: 36px;
        margin-right: 5px;
        border-radius: 50%;
        cursor: pointer;
      }

      a {
        color: #fff;
      }

      .profile-down {
        position: absolute;
        right: 0;
        top: 50%;
        margin-top: -10px;
        font-size: 20px;
        color: #cccccc;
      }
    }
  }

  nav {
    width: 100%;
    height: 60px;
    // overflow: hidden;

    ul {
      float: right;

      li.active .item {
        background: rgba(255, 255, 255, 0.31);
      }

      li {
        float: left;
        cursor: pointer;

        .item {
          display: inline-block;
          width: 130px;
          height: 60px;
          line-height: 60px;
          text-align: center;
          color: #ffffff;

          &.console {
            background-color: #ec1c1c;
            color: #fff;
            display: inline-block;
            margin-left: 30px;
            height: 26px;
            line-height: 26px;
            margin-top: 17px;
            text-align: center;
            border-radius: 4px;
            cursor: pointer;

            &:hover {
              background-color: #d60000;
              color: #fff;
            }
          }
        }

        .item:hover {
          /*color: red;*/
          background: rgba(255, 255, 255, 0.31);
        }
      }
    }
  }

  .jzq-logo {
    img {
      width: 176%;
    }
  }

  .logout {
    position: absolute;
    line-height: 60px;
    text-align: center;
    cursor: pointer;
    right: 5px;
    top: 0;
    z-index: 10;
    color: #cccccc;
    white-space: nowrap;
    display: flex;
    align-items: center;

    div {
      width: 20px;
      height: 20px;
      background: url("../static/images/logout.png") no-repeat;
      background-size: cover;
      margin-right: 5px;
    }

    &:hover {
      color: red;

      div {
        background: url("../static/images/logoutHover.png") no-repeat;
        background-size: cover;
      }
    }
  }
}

.my-el-header {
  position: fixed;
  width: 100%;
  top: 0;
  left: 0;
  /*z-index: 2;*/
  z-index: 500;
  height: 60px !important;
  /*background-color: #290202;*/
  background-color: #ec1c1c;
  /*background:rgba(41,2,2,0.4);*/
  color: #ffffff;
  box-shadow: 0px 2px 8px 0px rgba(38, 38, 38, 0.35);
  transition: all ease-in 0.2s;
}

.homePage {
  /*background: rgba(41, 2, 2, 0.4);*/
}

.user-content {
  position: absolute;
  top: -30px;
  background: #ffffff;
  width: 70%;
  left: 0;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);

  .footer {
    background-color: #f0f0f0;
    padding: 0 12px;

    .logout {
      text-align: right;
    }

    .sign .hasSign {
      text-align: left;
    }

    span {
      display: inline-block;
      margin-left: 10px;
      line-height: 38px;
      color: #525250;
      cursor: pointer;
    }

    .hasSign {
      span {
        color: #aaaaaa;
        cursor: default;
      }
    }
  }

  .nav-list {
    span {
      cursor: pointer;
    }

    .icon {
      max-width: 20px;
      max-height: 20px;
      vertical-align: top;
      margin-top: 5px;
      margin-right: 10px;
    }
  }

  .user-name {
    width: 90px;
    margin: 0 auto;
    text-align: center;
    -ms-flex-wrap: nowrap;
    flex-wrap: nowrap;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .img {
    text-align: center;
    margin-top: -40px;

    img {
      height: 80px;
      width: 80px;
      border-radius: 50%;
    }
  }
}

.ban-text {
  font-size: 50px;
  font-family: HuXiaoBo-NanShen;
  font-weight: 400;
  line-height: 54px;
  color: #ffffff;
  text-shadow: 0px 3px 8px rgba(194, 0, 0, 0.55);
  text-align: left;
  width: 1200px;
  margin: 0 auto;
  padding: 117px 70px 0 70px;
  box-sizing: border-box;

  img {
    width: 62px;
    height: auto;
    margin-left: 20px;
    vertical-align: middle;
  }

  span {
    font-size: 30px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #ffffff;
  }
}
.banner-style {
  background-size: 100% 100%;
  width: 100%;
  height: 260px;
  .img {
    width: 100%;
    height: 260px;
  }
}
.userHeader-wrap {
  width: 150px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  font-size: 14px;
  &:hover {
    overflow: initial;
    background: rgba(225, 225, 225, 0.3);
    .icon-arrow {
      transform: rotate(180deg);
    }
    ul {
      width: auto;
      height: auto;
      z-index: 100;
      display: block;
      top: 60px;
      opacity: 1;
    }
  }
  .info {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    box-sizing: border-box;
    padding-left: 10px;
    color: #ccc;
  }
  ul {
    width: 0;
    height: 0;
    z-index: -100;
    overflow: hidden;
    transition-property: opacity, top;
    transition-duration: 0.2s, 0.2s;
    transition-timing-function: ease;
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    opacity: 0;
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.16);
    li {
      cursor: pointer;
      background: #ffffff;
      width: 100%;
      height: 50px;
      line-height: 50px;
      color: #290202;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      &:hover {
        background: #f9f6f6;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// layouts/default.vue